import React from "react";
import style from "./HambugerTop.module.css";

const HambugerTop = (props) => {

    const {toggle} = props;

  return (
    <div className={style.hambuger} onClick={() => toggle(true)}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default HambugerTop;
